import { props as allSpecialsProps } from "@faire/web-api/routes/markets/event_type/all-specials";
import { props as myMarketListProps } from "@faire/web-api/routes/markets/event_type/all-specials/my-market-list";
import { Route } from "@faire/web/ui/routing/Route";
import { Switch } from "@faire/web/ui/routing/Switch";
import React from "react";

import { LazyPreShowMain } from "./__internal__/LazyPreShowMain";

export const PreShowRouter: React.FC = () => {
  return (
    <Switch>
      <Route {...myMarketListProps} component={LazyPreShowMain} />
      <Route {...allSpecialsProps} component={LazyPreShowMain} />
    </Switch>
  );
};
